import React, { useState } from "react";
import { ModalTask } from "./ModalTask";

export const BtnGiaHan = ({ item, onReload, disabled }) => {
    const [show, setShow] = useState(false);
    return (
        <>
            <a type="button" className="popover-basic"  disabled={disabled} onClick={() => setShow(true)} title="Gia hạn">
                <img src="/app-assets/images/icon-gia-han.png" alt="Gia hạn" />
            </a>
            {show && <ModalTask mode="extend" item={item} show={show} onHide={() => setShow(false)} onSaved={() => { setShow(false); onReload(); }} />}
        </>
    );
};

